import React, { useEffect, useState } from "react";
import HomeBannerAbout from "./HomeBannerAbout";
import { fetchbannerlistmo } from "../services/HomeBannerMobilelist";
import { fetchbannerlistdesk } from "../services/HomeBannerdesklist";
import { API_BASE } from "../api/apiConfig";

export default function HomeBannerDesktop({ activeCard, setActiveCard }) {
  const [cards, setCards] = useState([]);

  // Icons
  const GraduationIcon = () => (
    <span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-graduation-cap h-4.5 w-4.5"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg></span>
  );

  const UsersIcon = () => (
    <span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users h-4.5 w-4.5"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg></span>
  );

  const GlobeIcon = () => (
    <span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe h-4.5 w-4.5"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"></path><path d="M2 12h20"></path></svg></span>
  );
  

   // ✅ FIXED CONFIG (your requirement)
  /*const configMap = {
    travel_stories: {
      icon: <GraduationIcon />,
      subtitle: "Skill-Building",
      cta: "Learn While You Travel",
      href: "/ExperienceTrips",
    },
    local_experts: {
      icon: <UsersIcon />,
      subtitle: "Adventures",
      cta: "Find Your Tribe",
      href: "/grouptrips",
    },
    community: {
      icon: <GlobeIcon />,
      subtitle: "Free to Join",
      cta: "Connect Locally",
      href: "/community",
    },
  };*/

  const configMap = {
    "Skill-Building": {
      icon: <GraduationIcon />,
      subtitle: "Skill-Building",
      cta: "Learn While You Travel",
      href: "/ExperienceTrips",
    },
    "Adventures": {
      icon: <UsersIcon />,
      subtitle: "Adventures",
      cta: "Find Your Tribe",
      href: "/grouptrips",
    },
    "Free to Join": {
      icon: <GlobeIcon />,
      subtitle: "Free to Join",
      cta: "Connect Locally",
      href: "/community",
    },
  };

  // ✅ API LOAD
  useEffect(() => {
    const loadBanners = async () => {
      const isMobile = window.innerWidth < 1024;

      const res = isMobile
        ? await fetchbannerlistmo()
        : await fetchbannerlistdesk();

      if (res?.status && Array.isArray(res.data)) {
        /*const keys = Object.keys(configMap);*/

        /*const formatted = res.data.slice(0, 3).map((item, index) => {
          // 👇 try API key first, else fallback to index
          const key = item.type || keys[index];
          const config = configMap[key] || {};*/
        const formatted = res.data
        .filter(item => configMap[item.page_name])
        .map((item) => {
          const config = configMap[item.page_name];

          return {
            id: item.id,
            title: item.heading,
            desc: item.paragraph,
            img: `${API_BASE}/${item.banner_img}`,
            ...config,
          };
        });

        setCards(formatted);
      }
    };

    loadBanners();
  }, []);

  if (!cards.length) return null;

  return (
    
    <div className="relative container mx-auto px-6 hidden lg:block pt-24 pb-14">

        {/* Heading Section */}
        <div className="flex flex-row items-end justify-between gap-12 mb-14">
          <div className="max-w-2xl">
            <p className="text-primary text-sm font-semibold tracking-wider uppercase mb-3">
              India's Travel Community
            </p>
            <h1 className="text-5xl font-bold text-white leading-tight tracking-tight mb-2">
              Every Connecting Traveller <br />
              trip will teach you <br />
              <span className="text-primary">something new.</span>
            </h1>
          </div>

          <div className="flex flex-shrink-0 items-center transition-all duration-700 delay-200 opacity-100 translate-y-0">
            <a
              className="group relative inline-flex items-center gap-3 rounded-full border border-white/20 bg-white/5 backdrop-blur-sm pl-4 pr-2 py-2 text-sm font-medium text-white hover:bg-white/10 hover:border-white/40 transition-all cursor-pointer"
              href="/about"
            >
              <span className="relative">
                Know about us
                <span className="absolute -bottom-0.5 left-0 w-0 h-px bg-primary transition-all duration-300 group-hover:w-full" />
              </span>
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-primary text-white transition-transform group-hover:scale-110">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-arrow-right h-4 w-4 transition-transform group-hover:translate-x-0.5"
                >
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
                </svg>
              </span>
            </a>
          </div>

        </div>

        {/* ================= CARDS ================= */}
        <div className="flex gap-3">
        {cards.map((card, index) => {
          const isActive = activeCard === index;

          return (
            <a
              key={card.id}
              href={card.href}
              onMouseEnter={() => setActiveCard(index)}
              className={`relative overflow-hidden rounded-2xl border border-white/10 transition-all duration-500 ${
                isActive ? "flex-[2.5]" : "flex-1"
              }`}
              style={{ height: 220 }}
            >
              {/* Background */}
              <div className="absolute inset-0">
                <img
                  src={card.img}
                  alt={card.title}
                  className={`w-full h-full object-cover transition-transform duration-700 ${
                    isActive ? "scale-105" : "scale-100"
                  }`}
                />
                <div
                  className={`absolute inset-0 ${
                    isActive
                      ? "bg-gradient-to-r from-slate-950/80 via-slate-950/40 to-transparent"
                      : "bg-slate-950/60"
                  }`}
                />
              </div>

              {/* Content */}
              <div className="absolute inset-0 flex flex-col justify-between p-5 text-white">

                {/* Top */}
                <div className="flex items-center gap-2">
                  <div
                    className={`flex items-center justify-center w-9 h-9 rounded-xl ${
                      isActive
                        ? "bg-primary text-white"
                        : "bg-white/15 backdrop-blur-sm"
                    }`}
                  >
                    {card.icon}
                  </div>

                  <span className="text-white/70 text-xs uppercase">
                    {card.subtitle}
                  </span>
                </div>

                {/* Bottom */}
                <div>
                  <h3 className="text-lg font-bold mb-1">
                    {card.title}
                  </h3>

                  {isActive && (
                    <>
                      <p className="text-white/60 text-sm mb-2">
                        {card.desc}
                      </p>

                      <div className="text-primary text-sm font-medium">
                        {card.cta} →
                      </div>
                    </>
                  )}
                </div>

              </div>
            </a>
          );
        })}
      </div>
      </div>
  );
}
